import { render } from "./NavbarMenuItem.vue?vue&type=template&id=c11f1478"
import script from "./NavbarMenuItem.vue?vue&type=script&lang=js"
export * from "./NavbarMenuItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__